import * as helper from './../../../Assets/Js/helper';
import * as Events from './Events';

export default class Videocam {
	constructor(videoElement) {
		this.element = videoElement;
		this.audioSelect = null;
		this.videoSelect = null;

		let el = document.createElement('div');
		helper.addClass(el, 'cam-denied');
		el.id = 'camdenied';
		el.innerHTML = '<img src="/VX/ChatRoulette/img/cam_denied_icon.png" alt="CamRoulette"/><p>Klicke hier zum<br/>Starten Deiner Cam</p>';
		this.element.parentNode.insertBefore(el, this.element);
		helper.addClass(this.element.parentNode, 'denied-cam');
		helper.addEventListener(window, Events.START_GUEST_CAM, () => {
			let el = helper.$('#camdenied');
			if (el) {
				helper.removeClass(el.parentNode, 'denied-cam');
				el.parentNode.removeChild(el);
			}
			this._start();
		});
	}

	_start() {
		if (typeof navigator.mediaDevices === 'undefined' || typeof navigator.mediaDevices.enumerateDevices !== 'function') {
			this._handleError('Ihre Webcam konnte<br>nicht gefunden werden.');
			return;
		}

		navigator.mediaDevices.enumerateDevices()
			.then(this._gotDevices.bind(this))
			.then(this._getStream.bind(this))
			.catch(this._handleError.bind(this));
	}

	_gotDevices(deviceInfos) {
		for (let i = 0; i < deviceInfos.length; ++i) {
			const deviceInfo = deviceInfos[i];
			if (deviceInfo.kind === 'audioinput') {
				this.audioSelect = deviceInfo.deviceId;
			} else if (deviceInfo.kind === 'videoinput') {
				this.videoSelect = deviceInfo.deviceId;
			}

			if (this.audioSelect !== null && this.videoSelect !== null)  {
				break;
			}
		}
	}

	_getStream() {
		if (window.stream) {
			window.stream.getTracks().forEach(function (track) {
				track.stop();
			});
		}

		const constraints = {
			audio: {
				optional: [{
					sourceId: this.audioSelect
				}]
			},
			video: {
				optional: [{
					sourceId: this.videoSelect
				}]
			}
		};

		navigator.mediaDevices.getUserMedia(constraints).then(this._gotStream.bind(this)).catch(this._handleError.bind(this));
	}

	_gotStream(stream) {
		window.stream = stream; // make stream available to console
		this.element.srcObject = stream;
	}


	_handleError(text = 'Sie haben Ihren Zugang<br> zu Ihren Ger&auml;ten verweigert.') {
		if (typeof text === 'object') {
			text = 'Sie haben Ihren Zugang<br> zu Ihren Ger&auml;ten verweigert.';
		}

		helper.addClass(this.element.parentNode, 'denied-cam');
		this.element.parentNode.innerHTML = `
					<div class="cam-denied" id="camdenied">
						<img src="/VX/ChatRoulette/img/cam_denied_icon.png" alt="CamRoulette"/>
						<p>${text}</p>
					</div>`;
	}
}
